import { render, staticRenderFns } from "./AdminConsole.vue?vue&type=template&id=6aaf1cc0&scoped=true&"
import script from "./AdminConsole.vue?vue&type=script&lang=js&"
export * from "./AdminConsole.vue?vue&type=script&lang=js&"
import style0 from "./AdminConsole.vue?vue&type=style&index=0&id=6aaf1cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaf1cc0",
  null
  
)

export default component.exports